import { render, staticRenderFns } from "./HealthAndFamilyIncomeProtection.vue?vue&type=template&id=431a8abe&"
import script from "./HealthAndFamilyIncomeProtection.vue?vue&type=script&lang=js&"
export * from "./HealthAndFamilyIncomeProtection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports